import lodash from 'lodash';
import { composeReducers } from 'common/util/composeReducers';
import {
    ACTIONS,
    SET_DATASET_VALUES,
} from 'institutionalAdmin/actions/descriptors';

export function loadAdminDescriptors(state, action) {
    if (!action || action.type !== ACTIONS.ADMIN_LOAD_DESCRIPTORS) {
        return state;
    }

    const { institutionId, descriptors, descriptorDataTypes } = action.payload;
    const currentDescriptors = lodash.get(state, ['descriptors', institutionId]);
    if (lodash.isEqual(currentDescriptors, descriptors)) {
        return state;
    }

    return {
        ...state,
        descriptorDataTypes: descriptorDataTypes,
        descriptors: {
            ...state.descriptors,
            [institutionId]: descriptors
        }
    };
}

export function createDescriptor(state, action) {
    if (!action || action.type !== ACTIONS.ADMIN_CREATE_DESCRIPTOR) {
        return state;
    }

    const { institutionId, descriptor } = action.payload;

    if (!institutionId || !descriptor) {
        return {
            ...state,
            descriptor: {}
        };
    }

    const currentDescriptors = lodash.get(state, ['descriptors', institutionId]);
    if (lodash.includes(currentDescriptors, descriptor)) {
        return state;
    }

    return {
        ...state,
        descriptors: {
            ...state.descriptors,
            [institutionId]: [...currentDescriptors, descriptor]
        }
    };
}

export function deleteDescriptor(state, action) {
    if (!action || action.type !== ACTIONS.ADMIN_DELETE_DESCRIPTOR) {
        return state;
    }

    const { institutionId, descriptor } = action.payload;

    const currentDescriptors = lodash.get(state, ['descriptors', institutionId]);
    if (!lodash.includes(currentDescriptors, descriptor)) {
        return state;
    }

    let updatedDescriptors = currentDescriptors.filter(function(item) {
        return item.id !== descriptor.id;
    });

    return {
        ...state,
        descriptors: {
            ...state.descriptors,
            [institutionId]: [...updatedDescriptors]
        }
    };
}


export function updateDescriptor(state, action) {
    if (!action || action.type !== ACTIONS.ADMIN_UPDATE_DESCRIPTOR) {
        return state;
    }

    const { institutionId, descriptor } = action.payload;
    if (!descriptor) {
        return state;
    }

    const currentDescriptors = lodash.get(state, ['descriptors', institutionId]);
    let updatedDescriptors = currentDescriptors.filter(function(item) {
        return item.id !== descriptor.id;
    });
    updatedDescriptors.push(descriptor);

    return {
        ...state,
        descriptors: {
            ...state.descriptors,
            [institutionId]: [...updatedDescriptors]
        }
    };
}

function setDescriptorDatasetValues(state, action) {
    if (!action || action.type !== SET_DATASET_VALUES) {
        return state;
    }

    const { descriptorId, values, institutionId } = action.payload;

    const descriptors = lodash.get(state, `descriptors.${institutionId}`);
    const index = lodash.findIndex(descriptors, d => d.id === descriptorId);
    if (index === -1) {
        //console.error('unable to find descriptor: ', descriptorId);
        return state;
    }
    const newState = { ...state };
    lodash.set(newState, `descriptors.${institutionId}[${index}].dataset.values`, values);
    return newState;
}

export default composeReducers(loadAdminDescriptors, createDescriptor, deleteDescriptor, updateDescriptor, setDescriptorDatasetValues);
